import { useTranslation } from 'react-i18next';

export default function CTA() {
  const { t } = useTranslation();
  return (
    <section className="py-16 md:py-24 relative overflow-hidden" style={{ background: 'linear-gradient(180deg, #0c0814 0%, #150e28 100%)' }}>
      <div className="absolute inset-0 grid-bg pointer-events-none opacity-60" />
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[450px] rounded-full opacity-18"
          style={{ background: 'radial-gradient(ellipse, rgba(168,85,247,0.35) 0%, transparent 70%)' }} />
      </div>
      <div className="absolute top-0 left-0 right-0 divider-purple" />
      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-6 text-center">
        <div className="badge-purple mx-auto mb-8" style={{ display: 'inline-flex' }}>
          <div className="w-1.5 h-1.5 bg-purple-400 rounded-full animate-pulse"></div>
          {t('cta.badge')}
        </div>
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 md:mb-6 leading-tight font-heading">
          {t('cta.title1')} <span className="text-gradient-aurora">{t('cta.title2')}</span><br />{t('cta.title3')}
        </h2>
        <p className="text-base md:text-xl text-white/45 mb-8 md:mb-12">{t('cta.desc')}</p>
        <a href="https://www.polywin.ai/" target="_blank" rel="nofollow noopener noreferrer" className="px-8 md:px-12 py-4 md:py-5 rounded-full text-base md:text-lg font-black hover:scale-105 transition-all inline-flex items-center gap-3 whitespace-nowrap cursor-pointer text-white"
          style={{ background: 'linear-gradient(135deg,#9333ea,#7c3aed)', boxShadow: '0 6px 32px rgba(147,51,234,0.45)' }}>
          {t('cta.btn')}
          <i className="ri-arrow-right-line text-xl md:text-2xl"></i>
        </a>
        <div className="mt-14 md:mt-20 grid grid-cols-2 md:flex md:flex-wrap justify-center items-center gap-5 md:gap-12">
          {[
            { icon: 'ri-shield-check-line', labelKey: 'cta.trust0' },
            { icon: 'ri-verified-badge-line', labelKey: 'cta.trust1' },
            { icon: 'ri-group-line', labelKey: 'cta.trust2' },
            { icon: 'ri-money-dollar-circle-line', labelKey: 'cta.trust3' },
          ].map(item => (
            <div key={item.labelKey} className="flex items-center gap-2 md:gap-3 justify-center">
              <div className="w-10 md:w-11 h-10 md:h-11 rounded-full bg-purple-400/10 border border-purple-400/20 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-lg md:text-xl text-purple-400`}></i>
              </div>
              <span className="text-white/60 font-medium text-sm md:text-base whitespace-nowrap">{t(item.labelKey)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
